<template>
  <div class="user-page">
    <div class="uk-grid-medium" uk-grid>
      <PageHeader :title="$t('sideNav.Search')" class="uk-width-4-4@m" icon="uil-search-alt"/>
      <div class="uk-width-5-5">
        <searching :searchValue="search" @searchFor="searchResults"></searching>
        <template v-if="search.trim()">
          <!-- LOADING BOX -->
          <default-loading v-if="page_loading" :minHeight="'80vh'"></default-loading>
          <template v-else>
            <div class="section-header pb-0 mt-2 mb-4">
              <div class="section-header-left">
                <h4 class="uk-text-truncate">
                  <i class="uil-search-alt"></i> "{{ search }}" Aramasında
                  {{
                    totalItems(assignments) +
                    totalItems(posts) +
                    totalItems(collections)
                  }}
                  sonuç bulundu.
                </h4>
              </div>
            </div>

            <div v-if="totalItems(assignments)" class="uk-card-default uk-card-small rounded mt-2">
              <div class="section-header-left">
                <h4 class="uk-text-truncate pt-4 pl-4">
                  <i class="uil-file-search-alt"></i> {{ $t("general.trainings_assigned_to_me") }} ({{
                    totalItems(assignments)
                  }})
                </h4>
              </div>
              <template v-for="(assignment, index) in formattedAssignments">
                <SearchingResultItem :id="assignment.id" :key="'assignment_list_item_' + index"
                                     :hashtags="assignment.hashtags" :image="assignment.cover_image_link"
                                     :sub-title="assignment.description"
                                     :title="assignment.name"
                                     @click="openAssignmentDetails"></SearchingResultItem>
              </template>
            </div>

            <div v-if="CollectionVisible && totalItems(collections)" class="uk-card-default uk-card-small rounded mt-2">
              <div class="section-header-left">
                <h4 class="uk-text-truncate pt-4 pl-4">
                  <i class="uil-file-search-alt"></i>
                  {{ collectionTitle }} ({{
                    totalItems(collections)
                  }})
                </h4>
              </div>
              <div class="p-3">
                <div class="uk-child-width-1-4@m uk-child-width-1-4@s course-card-grid uk-grid-match" uk-grid>
                  <template v-for="(collection, index) in formattedCollections">
                    <collection :key="'collection_list_item_' + index" :collection="collection"
                                @onClickCard="openCollectionDetails"></collection>
                  </template>
                </div>
              </div>
            </div>

            <div v-if="socialPostVisible && totalItems(posts)" class="uk-card-default uk-card-small rounded mt-2">
              <div class="section-header-left">
                <h4 class="uk-text-truncate pt-4 pl-4">
                  <i class="uil-file-search-alt"></i> {{ $t("sideNav.Wall") }}
                  ({{
                    totalItems(posts)
                  }})
                </h4>
              </div>

              <template v-for="(post, index) in formattedPosts">
                <wall-item :id="post.id" :key="'social_post_item_' + index" :description="post.text"
                           :image="post?.user?.photo_link" :name="post?.user?.name" :name-tag="(post?.user?.name + '.' + post?.user?.surname).toLowerCase()
                    "
                           :time="timeFromNow(post.created_at)" @click="openSocialPost"></wall-item>
              </template>
            </div>
          </template>
          <Pagination v-if="assignments && assignments.data && assignments.last_page !== 1" :page.sync="pageProxy"
                      :paginate="assignments"/>
        </template>
        <popular-tags :search="search" @updateSearch="searchResults"></popular-tags>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/tr';
import 'moment/locale/en-gb';

import Searching from "@/view/components/index/Searching";
import PopularTags from "@/view/components/search/PopularTags";
import SearchingResultItem from "@/view/components/search/SearchingResultItem";
import WallItem from "@/view/components/search/WallItem";
import Collection from "@/view/components/index/Collection";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/view/components/dataTable/Pagination";
import PageHeader from "@/view/components/common/PageHeader.vue";

import {
  GET_ITEMS as REST_GET_ITEMS,
  LOADING as REST_LOADING,
} from "@/core/services/store/REST.module";
import seraching_module, {
  GET_ITEMS as SEARCH_GET_ITEMS,
  LOADING,
  MODULE_NAME as SEARCH_MODULE_NAME,
} from "@/core/services/store/searching.module";

import new_assignment_module, {
  BASE_URL as ASSIGNMENT_BASE_URL,
  MODULE_NAME as ASSIGNMENT_MODULE_NAME,
  ITEMS as ASSIGNMENT_ITEMS,
  GET_ITEMS as ASSIGNMENT_GET_ITEMS,
  LOADING as ASSIGNMENT_LOADING,
} from "@/core/services/store/assignment.module";

import new_social_module, {
  BASE_URL as SOCIAL_BASE_URL,
  MODULE_NAME as SOCIAL_MODULE_NAME,
  ITEMS as SOCIAL_ITEMS,
  GET_ITEMS as SOCIAL_GET_ITEMS,
  LOADING as SOCIAL_LOADING,
} from "@/core/services/store/social_post.module";

const _SOCIAL_MODULE = SOCIAL_MODULE_NAME;
const _ASSIGNMENT_MODULE = ASSIGNMENT_MODULE_NAME;
export default {
  name: "Search",
  components: {
    Searching,
    PopularTags,
    SearchingResultItem,
    WallItem,
    Collection,
    DefaultLoading,
    Pagination,
    PageHeader
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_SOCIAL_MODULE, new_social_module);
    registerStoreModule(_ASSIGNMENT_MODULE, new_assignment_module);
  },
  data() {
    return {
      collectionUrl: "api/collection",
      search: "",
      page: 1,
      per_page: 10,
      order: "desc",
      sort: "id",
      collections: [],
      catalogSearchUrl: "api/training/user-assigned/search",
    };
  },
  computed: {
    posts: {
      get() {
        return store.getters[SOCIAL_MODULE_NAME + "/" + SOCIAL_ITEMS];
      },
      set(value) {
      },
    },
    page_loading: {
      get() {
        return (
            store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_LOADING] ||
            store.getters[ASSIGNMENT_MODULE_NAME + "/" + SOCIAL_LOADING] ||
            this.$store.getters[REST_LOADING]
        );
      },
      set(value) {
      },
    },
    assignments: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ITEMS];
      },
      set(value) {
      },
    },
    formattedPosts() {
      let items = this.posts;
      if (items === null || !("data" in items)) return [];

      return items.data;
    },
    formattedAssignments() {
      let results = [];
      if (this.assignments === null || !("data" in this.assignments)) return [];
      this.assignments.data.forEach((currentItem) => {
        let public_contents_tags = this.getHashtagsFromContents(
            currentItem.contents,
            [],
            []
        );
        let hashtags = public_contents_tags.hashtags;
        let existing_ids = public_contents_tags.existing_ids;
        currentItem.programs.forEach((program) => {
          let program_contents_tags = this.getHashtagsFromContents(
              program.contents,
              hashtags,
              existing_ids
          );
          hashtags = program_contents_tags.hashtags;
          existing_ids = program_contents_tags.existing_ids;
        });

        results.push({
          id: currentItem.id,
          name: currentItem.name,
          cover_image_link: currentItem.cover_image_link,
          hashtags: hashtags,
          description: currentItem.description ? currentItem.description : "-",
          has_gift: currentItem.has_gift
              ? this.$t("general.yes")
              : this.$t("general.no"),
          created_at: currentItem.created_at
              ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          start_end:
              currentItem.start_date && currentItem.end_date
                  ? moment(currentItem.start_date).format("DD-MM-YYYY") +
                  " / " +
                  moment(currentItem.end_date).format("DD-MM-YYYY")
                  : "-",
        });
      });

      return results;
    },
    formattedCollections() {
      let items = this.collections;
      if (items === null || !("data" in items)) return [];

      return items.data;
    },
    collectionTitle() {
      const azconDomains = [
        'azcon.anzerabase.com',
        'azcon.softinya.com',
      ];
      const host = window.location.host.split(':')[0].replace(/^www\./, '').toLowerCase();

      if (azconDomains.includes(host)) {
        return this.$t("general.library");
      }

      return this.$t("sideNav.My_collections");
    },
    pageProxy: {
      set(value) {
        this.page = value;
        this.getAssignmentResult();
      },
      get() {
        return this.page;
      },
    },
  },
  methods: {
    updateSearch(variable) {
      this.search = variable;
    },
    getHashtagsFromContents(contents, hashtags_list, existing_ids) {
      contents.forEach((content) => {
        content.hashtags.forEach((hashtag) => {
          if (!existing_ids.includes(hashtag.id)) {
            existing_ids.push(hashtag.id);
            hashtags_list.push({ id: hashtag.id, name: hashtag.name });
          }
        });
      });
      return { hashtags: hashtags_list, existing_ids: existing_ids };
    },
    getSocialPosts() {
      if (!this.socialPostVisible) {
        return false;
      }
      let self = this;
      this.$store.dispatch(SOCIAL_MODULE_NAME + "/" + SOCIAL_GET_ITEMS, {
        url: SOCIAL_BASE_URL,
        filters: {
          like: self.search,
          page: self.page,
          per_page: self.per_page,
          sort: self.sort,
          order: self.order,
        },
      });
    },
    getCollectionResult() {
      if (!this.CollectionVisible) {
        return false;
      }
      let self = this;
      this.$store
          .dispatch(REST_GET_ITEMS, {
            url: this.collectionUrl,
            filters: {
              search: self.search,
              page: self.page,
              per_page: self.per_page,
              sort: self.order,
              order_by: self.sort,
            },
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) {
            }
            if (typeof result.data !== "undefined") {
              self.collections = result.data.my_collections;
            }
          });
    },
    getCatalogResult() {
      let self = this;
      this.$store
          .dispatch(SEARCH_MODULE_NAME + "/" + SEARCH_GET_ITEMS, {
            url: this.catalogSearchUrl,
            filters: {
              search: self.search,
              page: self.page,
              per_page: self.per_page,
              sort: self.sort,
              order: self.order,
              by_user: true,
              hashtags: true
            },
          })
          .then((result) => {
            if (result?.data?.length > 0) {
              // this.assignments.data = result.data;
            }
          });
    },
    getAssignmentResult() {
      let self = this;
      this.$store.dispatch(
          ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_GET_ITEMS,
          {
            url: ASSIGNMENT_BASE_URL,
            filters: {
              search: self.search,
              page: self.page,
              per_page: self.per_page,
              sort: self.order,
              order: self.sort,
              by_user: true,
              hashtags: true,
              with_expired: false,
            },
          }
      );
    },
    openAssignmentDetails(id) {
      this.$router.push({ name: "user.assignment-detail", params: { id: id } });
    },
    openSocialPost(id) {
      this.$router.push({ name: "user.wall", params: { id: id } });
    },
    openCollectionDetails(id) {
      this.$router.push({ name: "user.collection-detail", params: { id: id } });
    },
    totalItems(items) {
      if (items === null || !("data" in items)) return 0;
      return items.total;
    },
    searchResults(val) {
      if (this.search !== val.trim() && val.trim() !== "") {
        this.search = val.trim();
        this.getAllResults();
      }
      this.search = val.trim();
    },
    getAllResults() {
      this.getAssignmentResult();
      this.getSocialPosts();
      this.getCollectionResult();
      this.getCatalogResult()
    },
    timeFromNow(date) {
      // return moment(date).locale(this.secureLocalStorage("language") === 'en' ?
      //   this.secureLocalStorage("language") + '-gb' : this.secureLocalStorage("language")).fromNow();
      return moment(date).locale(this.secureLocalStorage("language")).format('DD MMMM YYYY')
    },
  },
  mounted() {
    this.searchResults(this.search)
  },
};
</script>

<style scoped></style>
